// extracted by mini-css-extract-plugin
export var button = "_mw-0";